import {
  getPromptList,
  postCheckAlbum,
  postLikesAdd,
  postLikesCancel,
  postPromptView,
} from "@/pages/Gallery/api";
import { loginStore } from "@/modules/login/store";
import { useAsyncEffect } from "ahooks";
import { sensitiveWordCheck } from "@/utils/string";
import { Toast } from "@/components/Toast";
import { GalleryItemType, galleryStore, ImgAndPromptItemType } from "@/stores/gallery";
import { gallerySeed } from "@/pages/Gallery/components/Search";
import { AlbumData } from "@/pages/Gallery/components/Album";

const {
  galleryData: { page_size, sort, author },
  setGalleryData,
  setPageLoading,
  setEmpty,
  setWordCheckState,
} = galleryStore;
// 点赞
const handleLike = async (
  image_id: number,
  photos: GalleryItemType[],
  imgAndPromptList: ImgAndPromptItemType[],
  onLike?: (image: number) => void,
  onError?: (e: any) => void,
) => {
  try {
    await postLikesAdd({ image_id });
    // if (onLike) {
    //   onLike(image_id);
    // } else {
    photos.forEach((item) => {
      if (item.image_id === image_id) {
        if (item.likes) {
          item.likes += 1;
        } else {
          item.likes = 1;
        }
        item.is_like = true;
      }
      return item;
    });
    imgAndPromptList.forEach((item) => {
      console.log(image_id, item.image_id, 22222);
      if (item.image_id === image_id) {
        if (item.likes) {
          item.likes += 1;
        } else {
          item.likes = 1;
        }
        item.is_like = true;
      }
      return item;
    });
    onLike?.(image_id);
    // }
  } catch (e) {
    console.error(e);
    onError && onError(e);
  }
};
//取消点赞
const handleCancelLike = async (
  image_id: number,
  photos: GalleryItemType[],
  imgAndPromptList: ImgAndPromptItemType[],
  onCancelLike?: (image: number) => void,
  onError?: (e: any) => void,
) => {
  try {
    await postLikesCancel({ image_id });
    // if (onCancelLike) {
    //   onCancelLike(image_id);
    // } else {
    photos.forEach((item) => {
      if (item.image_id === image_id) {
        if (item.likes) {
          item.likes -= 1;
        }
        item.is_like = false;
      }
      return item;
    });
    imgAndPromptList.forEach((item) => {
      if (item.image_id === image_id) {
        if (item.likes) {
          item.likes -= 1;
        }
        item.is_like = false;
      }
      return item;
    });
    onCancelLike?.(image_id);
    // }
  } catch (e) {
    console.error(e);
    onError && onError(e);
  }
};
// 点赞&取消点赞
export const onGiveTheThumbsUp = async (
  photos: GalleryItemType[],
  imgAndPromptList: ImgAndPromptItemType[],
  image_id: number,
  type?: boolean,
  onLike?: (image: number) => void,
  onCancelLike?: (image: number) => void,
  onError?: (e: any) => void,
) => {
  if (!loginStore.isLogin) {
    loginStore.openLoginDialog({}, async () => {
      if (type) {
        await handleLike(image_id, photos, imgAndPromptList, onLike, onError);
      } else {
        //取消点赞
        await handleCancelLike(image_id, photos, imgAndPromptList, onCancelLike, onError);
      }
    });
  } else {
    if (type) {
      await handleLike(image_id, photos, imgAndPromptList, onLike, onError);
    } else {
      //取消点赞
      await handleCancelLike(image_id, photos, imgAndPromptList, onCancelLike, onError);
    }
  }
};

export const getGallery: any = async (
  loadMore?: boolean,
  emptyKeywords?: boolean,
  pageIndex?: number,
  currentSort?: string,
  currentAuthor?: string,
) => {
  const { data } = await getPromptList({
    keywords: emptyKeywords ? "" : sessionStorage.keywords ?? "",
    page_index: !loadMore ? 1 : pageIndex ? pageIndex + 1 : 1,
    page_size: page_size,
    seed: gallerySeed(!loadMore),
    sort: currentSort ?? sort,
    author: currentAuthor ?? author,
  });
  if (!data?.list && !data?.counter) {
    setEmpty(true);
    const {
      data: { list: recommendList, counter: recommendCounter },
    } = await getPromptList({
      keywords: "",
      page_index: !loadMore ? 1 : pageIndex ? pageIndex + 1 : 1,
      page_size: page_size,
      seed: gallerySeed(true),
      sort: currentSort ?? sort,
      author: "author_all",
    });
    return { list: recommendList, counter: recommendCounter };
  } else {
    setEmpty(false);
    return { list: data?.list ?? [], counter: data?.counter };
  }
};
//首次进入gallery页面
export const useGalleryAsyncEffect = () => {
  return useAsyncEffect(async () => {
    setPageLoading(true);
    try {
      sessionStorage.keywords && (await sensitiveWordCheck(sessionStorage.keywords));
      setWordCheckState(true);
      const { list, counter } = await getGallery();
      setGalleryData({
        list: list ?? [],
        counter: counter ?? 0,
        page_size: page_size,
        page_index: 1,
        sort: sort,
        author: author,
      });
    } catch (e) {
      setWordCheckState(false);
      Toast({
        title: "当前搜索词内含有敏感词，请重新输入",
        status: "warning",
      });
      sessionStorage.keywords = "";
      const { list, counter } = await getGallery(false, true);
      if (!list || !counter) {
        setEmpty(true);
        const { list: recommendList, counter: recommendCounter } = await getGallery(false, true);
        setGalleryData({
          list: recommendList ?? [],
          counter: recommendCounter ?? 0,
          page_size: page_size,
          page_index: 1,
          sort,
          author,
        });
      } else {
        setGalleryData({
          list: list ?? [],
          counter: counter ?? 0,
          page_size: page_size,
          page_index: 1,
          sort,
          author,
        });
      }
    }

    setPageLoading(false);
  }, []);
};
// 加入相册
export const onAlbum = (type: number, albumData: AlbumData) => {
  galleryStore.galleryData.list.forEach((item) => {
    if (item.image_id === Number(albumData.image_id)) {
      if (type !== 2) {
        item.is_album = !item.is_album;
      }
      item.album_id = albumData.album_id;
      item.album_name = albumData.album_name;
      item.album_image_id = albumData.album_image_id;
    }
    return item;
  });
  galleryStore.imgAndPromptList.forEach((item) => {
    if (item.image_id === albumData.image_id) {
      if (type !== 2) {
        item.is_album = !item.is_album;
      }
      item.album_id = albumData.album_id;
      item.album_name = albumData.album_name;
      item.album_image_id = albumData.album_image_id;
    }

    return item;
  });
};
// 关注or取消关注
export const onFollow = (to_user_id: string) => {
  galleryStore.imgAndPromptList.forEach((item) => {
    if (item.user.user_id === to_user_id) {
      item.user.is_follow = !item.user.is_follow;
    }
    return item;
  });
};

export const usePromptViewCall = async (image_id: number) => {
  await postPromptView({ image_id });
};
//检测是否存在默认画册(登陆成功调取，用户创建默认画册)
export const useCheckAlbum = () => {
  return useAsyncEffect(async () => {
    await postCheckAlbum();
  }, []);
};
